import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { ClientConfigurationApproval } from '../models/client-configuration-approval.model';
import { ApiService } from './api.service';

@Injectable()
export class ClientConfigurationApprovalsService extends ApiService {
  private http = inject(HttpClient);

  readonly approved$ = new Subject<ClientConfigurationApproval>();

  getLatest(clientId: number): Observable<{ clientConfigurationApproval: ClientConfigurationApproval | null }> {
    return this.http.get<{ clientConfigurationApproval: ClientConfigurationApproval | null }>(
      `${environment.captureApi.url}/client_configuration_approvals/latest`,
      { params: { client_id: clientId } }
    );
  }

  getPending(clientId: number): Observable<{ clientConfigurationApproval: ClientConfigurationApproval | null }> {
    return this.http.get<{ clientConfigurationApproval: ClientConfigurationApproval | null }>(
      `${environment.captureApi.url}/client_configuration_approvals/pending`,
      { params: { client_id: clientId } }
    );
  }

  approve(id: number, clientId: number): Observable<{ clientConfigurationApproval: ClientConfigurationApproval }> {
    return this.http.patch<{ clientConfigurationApproval: ClientConfigurationApproval }>(
      `${environment.captureApi.url}/client_configuration_approvals/${id}`,
      {},
      { params: { client_id: clientId } }
    ).pipe(tap(result => this.approved$.next(result.clientConfigurationApproval)));
  }
}
